import React from "react";
import { useAppDispatch } from "../../../../app/hooks";
import { updateDynamicWeightPriceRange } from "./edit-position-slice";
import DynamicWeightPriceRange from "../../../../api/models/dynamicWeightPriceRange";
import { instanceToPlain } from "class-transformer";
import { NumberFormatValues, NumericFormat } from "react-number-format";

interface EditDynamicWeightPriceRangeProps {
  arrayIndex: number
  priceMin: number
  priceStep: number
  dynamicWeightPriceRange: DynamicWeightPriceRange
}

const EditDynamicWeightPriceRange: React.FC<EditDynamicWeightPriceRangeProps> = (props: EditDynamicWeightPriceRangeProps) => {
  // Get the 'dispatch' method from the store
  const dispatch = useAppDispatch();

  const priceMaxChangeHandler = (value: NumberFormatValues) => {
    const dynamicWeightPriceRange = props.dynamicWeightPriceRange;
    dynamicWeightPriceRange.priceMax = value.floatValue ?? 0;
    dispatch(updateDynamicWeightPriceRange({ arrayIndex: props.arrayIndex, dynamicWeightPriceRange: instanceToPlain(dynamicWeightPriceRange) }));
  }

  const weightChangeHandler = (value: NumberFormatValues) => {
    const dynamicWeightPriceRange = props.dynamicWeightPriceRange;
    dynamicWeightPriceRange.weight = value.floatValue ?? 0;
    dispatch(updateDynamicWeightPriceRange({ arrayIndex: props.arrayIndex, dynamicWeightPriceRange: instanceToPlain(dynamicWeightPriceRange) }));
  }

  return (
    <>
      {/** Price min */}
      <div className="col-span-4 items-center px-2 py-1">
        <div className='w-full text-center border border-neutral-300 bg-neutral-100'>{props.priceMin.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</div>
      </div>
      <div className="col-span-1 text-center">
        -
      </div>
      {/** Price max */}
      <div className="col-span-4 items-center px-2 py-1">
        <NumericFormat
          className="w-full border border-neutral-400 text-center"
          onValueChange={priceMaxChangeHandler}
          step={0.01}
          min={props.priceMin + 0.01}
          value={props.dynamicWeightPriceRange.priceMax}
          decimalSeparator=','
          thousandSeparator='.'
        />
      </div>
      {/** Weight */}
      <div className="col-span-3 items-center px-2 py-1">
        <NumericFormat
          className="w-full border border-neutral-400 text-center"
          onValueChange={weightChangeHandler}
          step={1}
          min={1}
          value={props.dynamicWeightPriceRange.weight}
          decimalSeparator=','
          thousandSeparator='.'
        />
      </div>
    </>
  )
}

export default EditDynamicWeightPriceRange;